import TodoList from "./TodoList";

const App = () => (
    <TodoList />
);

export default App;
